import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Filter } from '../../../@types/filter';
import { userApi } from '../../../apis';
import { EmployeeRelatedInformationDtoRolesEnum } from '../../../apis/client-axios';
import ButtonWrap from '../../../components/ButtonWrap';
import SvgEye from '../../../components/svg/SvgEye';
import TableWrap from '../../../components/TableWrap';
import Widget from '../../../components/Widget';
import { ATTENDANCE_MANAGEMNT_API } from '../../../constants/QueryKey';
import { ADMIN_ROUTE_NAME } from '../../../constants/RouteName';
import { RootState } from '../../../store';
import './style.scss';
const AttendanceManagement = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [filter, setFilter] = useState<Filter>({ page: 1, pageSize: 20, fullTextSearch: '' });
  const { data: dataSource, isLoading } = useQuery({
    queryKey: [ATTENDANCE_MANAGEMNT_API, filter],
    queryFn: () =>
      userApi.userControllerGetAllEmployeesByManager(filter.page, filter.pageSize, undefined, filter.fullTextSearch),
    enabled: !!filter,
  });
  const role = useSelector((state: RootState) => state.auth.authUser?.role);
  useEffect(() => {
    if (role && role !== EmployeeRelatedInformationDtoRolesEnum.Manager) {
      navigate(-1);
    }
  }, [navigate, role]);

  const onClickDetail = (detail) => {
    navigate('/' + ADMIN_ROUTE_NAME.ATTENDANCE_MANAGEMENT + `/${detail.id}`);
  };
  const columns = [
    {
      title: 'No.',
      dataIndex: 'employeeId',
      key: 'employeeId',
      render: (value, record, index) => {
        return <p className="attendance-management_table-column-data">{index + 1}</p>;
      },
    },
    {
      title: intl.formatMessage({ id: 'attendance.management.column.name' }),
      dataIndex: 'name',
      key: 'name',
      render: (record) => {
        return <p className="attendance-management_table-column-data">{record}</p>;
      },
    },
    {
      title: '',
      dataIndex: 'option',
      key: 'option',
      render: (_, record, index) => {
        return (
          <ButtonWrap onClick={() => onClickDetail(record)} className="attendance-management_table-column-button">
            <SvgEye />
            {intl.formatMessage({ id: 'attendance.management.button.view' })}
          </ButtonWrap>
        );
      },
    },
  ];

  return (
    <div className="attendance-management">
      <Widget
        breadcrumbs={[intl.formatMessage({ id: 'attendance.management.breadcumb' })]}
        content={
          <TableWrap
            isPagination
            loading={isLoading}
            onSearch={(search) => {
              setFilter((prevFilters) => ({
                ...prevFilters,
                page: 1,
                fullTextSearch: search,
              }));
            }}
            tableProps={{
              dataSource: dataSource?.data.data?.content || [],
              columns,
              className: 'attendance-management_table',
              scroll: { x: 1300 },
            }}
          />
        }
        title={intl.formatMessage({ id: 'attendance.management.breadcumb' })}
      />
    </div>
  );
};
export default AttendanceManagement;
